const collator = new Intl.Collator('us-en', {
  numeric: true,
  sensitivity: 'base',
  usage: 'sort',
});

export const naturalStringComparator = (a = '', b = '') => collator.compare(a, b);
